
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {SettingsState} from "src/models/SettingsState";
import {resolveBaseUrl} from './../Utils/urlHelper';
const baseUrl = resolveBaseUrl();
export const chromosomeApi = createApi({
    reducerPath: 'chromosomeApi',
    baseQuery: fetchBaseQuery({baseUrl}),
    refetchOnMountOrArgChange: 3,
    endpoints: (builder) => ({
        getSettings: builder.query<SettingsState, void>({
            query: () => `chromosome/settings`
        }),
        postRenderRequest: builder.query<FormData, void>({
            query: () => `chromosome/render`
        }),
        download: builder.query<Blob, string>({
            query: (fileName: string) => ({
                url: `chromosome/download/${encodeURIComponent(fileName)}`,
                responseHandler: async (response) => {
                    if(!response.ok) {
                        throw new Error(`Download failed: ${response.status} ${response.statusText}`);
                    }
                    return await response.blob();
                }
            })
        })
    })
});

export const {endpoints, useGetSettingsQuery, useDownloadQuery} = chromosomeApi;